import React from 'react';

import { MdOutlineSearch } from 'react-icons/md';

import { useNewRefuel } from '../../../../hooks/useNewRefuel';

import {
  Container,
  TitleWrapper,
  Title,
  Subtitle,
  ControlsWrap,
  ButtonSelectAll,
  InputWrapper,
  InputSearch,
} from './styles';

const HeaderList: React.FC = () => {
  const [selectAll, setSelectAll] = React.useState(false);

  const {
    addAllSelectedBases,
    removeAllSelectedBases,
    filterTerm,
    handleFilterTerm,
  } = useNewRefuel();

  const handleSelectAll = (): void => {
    setSelectAll((prevSelectAll) => {
      if (!prevSelectAll) {
        addAllSelectedBases();
      } else {
        removeAllSelectedBases();
      }
      return !prevSelectAll;
    });
  };

  return (
    <Container>
      <TitleWrapper>
        <Title>Local de abastecimento</Title>
        <Subtitle>
          Selecione o local ou locais que deseja realizar o abastecimento do
          gás.
        </Subtitle>
      </TitleWrapper>
      <ControlsWrap>
        <ButtonSelectAll onClick={handleSelectAll}>
          {selectAll ? 'Deselecionar todos' : 'Selecionar todos'}
        </ButtonSelectAll>
        <InputWrapper>
          <MdOutlineSearch size={20} color="#3d3d3d" />
          <InputSearch
            placeholder="Pesquisar"
            value={filterTerm}
            onChange={(e) => handleFilterTerm(e.target.value)}
          />
        </InputWrapper>
      </ControlsWrap>
    </Container>
  );
};

export default HeaderList;
